import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "-4 0 64 64"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#4438CA",
      "fill-rule": "evenodd",
      d: "M5.15.006A5.074 5.074 0 0 0 .078 5.08v53.841a5.07 5.07 0 0 0 5.072 5.073h45.775a5.074 5.074 0 0 0 5.074-5.073V20.316L37.096.006z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("g", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd"
    }, [
      _createElementVNode("path", {
        fill: "#3830A3",
        d: "M55.977 20.352v1H43.178s-6.312-1.26-6.129-6.707c0 0 .208 5.707 6.004 5.707z"
      }),
      _createElementVNode("path", {
        fill: "#FFF",
        d: "M37.074 0v14.561c0 1.656 1.104 5.791 6.104 5.791h12.799z",
        opacity: ".5"
      })
    ], -1),
    _createElementVNode("g", { fill: "#FFF" }, [
      _createElementVNode("path", {
        "xmlns:ns0": "http://www.w3.org/2000/svg",
        d: "M22.644 27.413 20.8 21.889l-2.76-1.264.191-.418 2.942 1.347 1.907 5.714zM25.877 48.006l-3.001-1.33.186-.42 2.912 1.289 4.514-.007v.46z"
      }),
      _createElementVNode("path", {
        "xmlns:ns0": "http://www.w3.org/2000/svg",
        d: "m30.488 47.996-3.112-1.338.182-.423 2.66 1.144 9.034-25.503-2.566-1.26.203-.414 2.932 1.44-.073.215zM21.31 30.836l.19-.42 2.968 1.338-.19.42z"
      }),
      _createElementVNode("path", {
        "xmlns:ns0": "http://www.w3.org/2000/svg",
        d: "M24.369 31.725h4.283v.46H24.37z"
      }),
      _createElementVNode("path", {
        "xmlns:ns0": "http://www.w3.org/2000/svg",
        d: "m24.15 32.027.436-.149 2.15 6.279-.434.149z"
      }),
      _createElementVNode("g", { "xmlns:ns0": "http://www.w3.org/2000/svg" }, [
        _createElementVNode("path", { d: "M27.612 46.676h-4.736l-.054-.154-9.224-26.315h4.635l2.268 6.903h9.52l2.335-6.903 4.535-.007-9.28 26.476Zm-4.41-.46h4.083l8.957-25.555-3.554.006-2.336 6.903H20.169L17.9 20.667h-3.655z" }),
        _createElementVNode("path", { d: "M25.505 41.935H25l-3.925-11.547h8.351zm-3.787-11.087 3.535 10.398 3.532-10.398z" })
      ])
    ], -1)
  ]))]))
}
export default { render: render }